import Styles from './Sections.module.scss'
import { SectionProps } from './Types'
import { OTHER_CARD_OVERRIDES, OTHER_CATEGORIES, OTHER_CHANNELS } from '../constants'
import { WizardCategoryCardGrid } from '../WizardCategoryCard/WizardCategoryCard'
import { WizardButton, WizardCard } from '../WizardButton/WizardButton'
import { OtherCategories } from '../Types'

export const Other = (props: SectionProps) => {
  const subCategory = props.subCategory as OtherCategories
  const setSubCategory = props.setSubCategory

  if (subCategory) {
    return (
      <div className={Styles.commonSectionContainer}>
        <WizardCategoryCardGrid heading={`What do you want to make?`}>
          {OTHER_CHANNELS[subCategory].map((channel) => (
            <WizardButton
              key={channel}
              channelKey={channel}
              version={2}
              size="lg"
              cardInfoOverride={OTHER_CARD_OVERRIDES}
            />
          ))}
        </WizardCategoryCardGrid>
      </div>
    )
  }

  return (
    <div className={Styles.commonSectionContainer}>
      <WizardCategoryCardGrid heading="What do you want to make?">
        {OTHER_CATEGORIES.map((category) => (
          <WizardCard
            size="wide"
            key={category.name}
            title={category.label}
            description={category.description}
            image={category.image}
            onPress={() => setSubCategory(category.name)}
          />
        ))}
      </WizardCategoryCardGrid>
    </div>
  )
}
